export const PRODUCT_CHECKOUT_STEPS = ['Cart', 'Billing & address', 'Payment'];
